import type { ReactNode } from 'react';
import { drawElements } from '../../elements/layout_elements.ts';
import { CanvasView } from '../../view/canvas_view.tsx';
import { useLegacyIcon } from '../../view/icons.ts';
import { useTapCommand } from '../../view/tap_command.ts';
import { useTileTextColor } from '../../view/tile_style.ts';
import { ACTION_ICON_COLOR, actionTileElements, type ActionTile } from './action_tile.ts';

/** The content area of an `action` tile: its icon; a tap sends its command. */
export function ActionTileView({ tile }: { tile: ActionTile }) : ReactNode {
    const tap = useTapCommand(tile, tile.options.source);
    const icon = useLegacyIcon(tile.options.icon);
    const color = useTileTextColor(ACTION_ICON_COLOR);

    return (
        <div style={{ position: 'absolute', inset: 0, cursor: 'pointer' }} onClick={() => void tap(tile.options.command, tile.options.argument)}>
            <CanvasView deps={[icon, color]} draw={(ctx, width, height) => drawElements(ctx, { left: 0, top: 0, width, height }, actionTileElements(icon, color))} />
        </div>
    );
}
